import React from 'react';
import ContentLayout from '../core/ContentLayout';
import TermsOfUseContent from './TermsOfUseContent';

const TermsOfUse = () => {
    return (
        <ContentLayout titleTranslateId='termsOfUse.title'>
            <TermsOfUseContent height='600px' />
        </ContentLayout>
    );
}

export default TermsOfUse;
